// import initializeWooSelects from './woo/selects';
import initializeWooSliders from './woo/sliders';
import initializeWooForms from './woo/forms';
import initializeVariations from './woo/variations';
import initializeSingleProduct from './woo/product';

export default class WooCommerce {
    constructor() {
        this.initialize();
    }

    initialize() {
        // initializeWooSelects();
        initializeWooSliders();
        initializeWooForms();
        initializeVariations();
        initializeSingleProduct();
    }
}